import React from "react";
import { carrierFieldsPP } from "../formFields/shippmentTabsFields";
import GenericFormTab from "./GenericFormTab"; // adjust path

export default function CarrierTab({ formData, onChange , errors = {} , viewOnly = false , isEdit = true }) {
    return <GenericFormTab fields={carrierFieldsPP} formData={formData} onChange={onChange} errors={errors} readOnly={viewOnly} isEdit={isEdit} />;
}
